import actions from './unitTypesActions'
import {mutations} from './unitTypesMutations'

export default {
  namespaced: true,
  actions,
  mutations
}
